import React from 'react'
import { render } from 'react-dom'
import Parse from 'parse'
import ReactGA from 'react-ga';

import Main, {getURLParameter} from './Main.js'

// The pre-compiled calcuation bundle is imported globally, same with text
const layout = window.layout

// Set up and initialize Parse database
Parse.serverURL = 'https://parse.r8edge.no/tata'
const applicationId = 'r8-tata'
const clientKey = 'r8-js-tata'
Parse.initialize(applicationId, clientKey)

// GA
ReactGA.initialize('UA-112992930-1', {debug: true});
ReactGA.pageview(window.location.pathname + window.location.search);

const getOptionFunc = new Promise((resolve, reject) => {
  new Parse.Query(Parse.Object.extend('Settings'))
  .limit(1000)
  .find({
    success: (results) => {
      const options = results.map(object => object.toJSON()).reduce((list, item) => {
        return {
          ...list,
          [item.option_key]: item.option_value
        }
      }, {})
      const warnings = []
      const getOption = (key) => {
        if (options[key]) {
          return options[key]
        }
        if (!warnings.find(item => item === key)) {
          warnings.push(key)
          global.__DEVELOPMENT__ && console.warn(`Missing option-field for "${key}", this should be included in the database`)
        }
        return null
      }
      resolve(getOption)
    },
    error: reject
  })
})

const getPlates = new Promise((resolve, reject) => {
  new Parse.Query(Parse.Object.extend('Plate'))
  .limit(1000)
  .find({
    success: (results) => {
      const country = getURLParameter('country') || 'no'
      const products = results.map(object => object.toJSON()).filter(object => object.country === country)
      results.forEach((object, i) => {
        if (object.get('country') === country) {
          const p = object.get('props')
          if (p.nobb === undefined) {
            reject(new Error('Each plate must have a nobb number specified'))
          }
          if (p.height.type === 'stepwise' && (p.height.height.length !== p.nobb.length)) {
            reject(new Error('A stepwise defined plate should have a nobb for each length'))
          }
          if (p.height.type === 'stepwise') {
            for (let i = 0; i < p.height.height.length; i++) {
              p.height.height[i] *= 1
            }
          }
          // For all the extra products transform into a function if defined such
          // in the database
          if (p.products !== undefined) {
            p.products.map((it, i) => {
              if (!isFinite("New function", it.number)) {

                try {
                  p.products[i].number = new Function('area', 'mone', 'vindski','takfot', 'gradeGutter', '"use strict"; return ' + it.number)
                }
                catch(err) {
                  console.log(err, p.products[i], object.get("createdAt"), object);
                  p.products[i].number = () => 0;
                }
              } else {
                p.products[i].number = () => 1 * it.number;
              }
            });
          }
          layout.addplate(p)
        }
      })
      resolve(products)
    },
    error: reject
  })
})

const getProducts = new Promise((resolve, reject) => {
  new Parse.Query(Parse.Object.extend('Product'))
  .limit(1000)
  .find({
    success: resolve,
    error: reject
  })
})


export const getRoofTypes = new Promise((resolve, reject) => {
  new Parse.Query(Parse.Object.extend('RoofType'))
           .limit(1000)
           .find({
             success: function (results) {
               let sizes = {}
               for (var i = 0; i < results.length; i++) {
                 var object = results[i]
                 let p = object
                 // Sanity check nobb to length:
                 sizes[p.get('Name')] = p.get('Buffer')
                 sizes[p.get('RoofType')] = p.get('Buffer')
               }

               resolve(results.map((item) => item.toJSON()))
             },
             error: reject
           }).catch(e => {
             console.error(e)
             reject(e)
           })
})

Promise.all([
  getOptionFunc,
  getPlates,
  getProducts,
  getRoofTypes
]).then(([getOption, plates, products, roofTypes]) => {

  const productOptions = products.map(item => item.toJSON()).map(({name, nobb, text, optional, image, category}) =>
    {
      let o = {name, nobb, text, optional, image}
      if(category==undefined) {
        category = "TILBEHØR"
      }
      category = ("" + category).toLowerCase()
      o.category = category
      return o
    });

  render(<Main
           Parse={Parse}
           layout={layout}
           getOption={getOption}
           plates={plates}
           productOptions={productOptions}
           roofTypes={roofTypes}
  />, document.getElementById('app'))
}).catch((error) => {
  if (error.code === 209) {
    Parse.User.logOut()
    return global.location.reload()
  }
  console.log('Global error', error)
})



// WEBPACK FOOTER //
// ./app.js